import { useEffect } from "react";
import { ContainerV2, H1, P, ButtonV2, InfoV2 } from "../../Atoms";
import { Tracking } from "../../../services/Tracking";
import { maskMoney } from "../../../utils/masks";
import { useConfirmAppointmentV2 } from "./useConfirmAppointmentV2";

export const ConfirmAppointmentV2 = () => {
  const {
    stepIndicator,
    dataHoraLabel,
    localNome,
    localEndereco,
    servico,
    veiculoModelo,
    veiculoPlaca,
    valorPago,
    checklistHref,
    isBaixandoRecibo,
    isReciboIndisponivel,
    handleBaixarChecklist,
    handleBaixarRecibo,
    handleVerMeusAgendamentos,
    handleVoltarAoInicio,
  } = useConfirmAppointmentV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/confirmar-agendamento:pageview");
  }, []);

  return (
    <ContainerV2 backButton={false}>
      {stepIndicator}
      <H1 className="mb-4 mt-8">Agendamento criado</H1>
      <P className="mb-8 text-[#666666]">
        Tudo certo! Você pode acompanhar e gerenciar os seus agendamentos
        através do painel. Baixe também o checklist para entender tudo que
        será inspecionado no seu veículo.
      </P>

      <div className="mx-auto flex w-full max-w-[560px] flex-col gap-[25px]">
        <div className="flex flex-col gap-4 rounded-3xl border border-solid border-[#adb7b5] bg-white p-8 shadow-[0_8px_24px_0_rgba(0,0,0,0.078)]">
          <div className="flex flex-col gap-2.5 border-x-0 border-b border-t-0 border-solid border-[#e5e5ea] pb-4 sm:flex-row sm:justify-end">
            <ButtonV2
              href={checklistHref}
              download
              onClick={handleBaixarChecklist}
              className="h-auto w-full min-w-0 justify-center gap-2 rounded-full bg-[#20332f] px-2 py-2 font-['Inter'] text-xs font-normal text-white sm:w-fit"
            >
              <img
                src="/assets/svgs/icon-save-alt-white.svg"
                alt=""
                className="h-3.5 w-3.5"
              />
              Baixar checklist de vistoria
            </ButtonV2>
            <ButtonV2
              type="button"
              disabled={isBaixandoRecibo || isReciboIndisponivel}
              onClick={handleBaixarRecibo}
              className="h-auto w-full min-w-0 justify-center gap-2 rounded-full bg-[#20332f] px-2 py-2 font-['Inter'] text-xs font-normal text-white disabled:opacity-60 sm:w-fit"
            >
              <img
                src="/assets/svgs/icon-save-alt-white.svg"
                alt=""
                className="h-3.5 w-3.5"
              />
              Baixar recibo de agendamento
            </ButtonV2>
          </div>

          <div className="flex flex-col">
            <div className="grid grid-cols-1 gap-4 border-x-0 border-b border-t-0 border-solid border-[#e5e5ea] py-4 sm:grid-cols-2">
              <div className="flex flex-col gap-2.5">
                <span className="flex items-center gap-1.5 font-['Mulish'] text-[10px] text-[#666666]">
                  <img
                    src="/assets/svgs/icon-calendar-today-gray.svg"
                    alt=""
                    className="h-2.5 w-2.5"
                  />
                  Data e horário
                </span>
                <span className="font-['Mulish'] text-base font-bold text-[#20332f]">
                  {dataHoraLabel ?? "---"}
                </span>
              </div>

              <div className="flex flex-col gap-2.5">
                <span className="flex items-center gap-1.5 font-['Mulish'] text-[10px] text-[#666666]">
                  <img
                    src="/assets/svgs/icon-place-gray.svg"
                    alt=""
                    className="h-2.5 w-2.5"
                  />
                  Local
                </span>
                <div>
                  <p className="font-['Mulish'] text-base font-bold text-[#20332f]">
                    {localNome ?? "---"}
                  </p>
                  <p className="font-['Mulish'] text-[10px] text-[#2d2d2d]">
                    {localEndereco ?? "---"}
                  </p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-4 border-x-0 border-b border-t-0 border-solid border-[#e5e5ea] py-4 sm:grid-cols-2">
              <div>
                <p className="font-['Mulish'] text-[10px] text-[#666666]">
                  Serviço
                </p>
                <p className="font-['Mulish'] text-base font-bold text-[#20332f]">
                  {servico ?? "---"}
                </p>
              </div>

              <div>
                <p className="font-['Mulish'] text-[10px] text-[#666666]">
                  Veículo
                </p>
                <p className="font-['Mulish'] text-base font-bold text-[#20332f]">
                  {veiculoModelo ?? "---"}
                </p>
                <p className="font-['Mulish'] text-xs text-[#20332f]">
                  {veiculoPlaca}
                </p>
              </div>
            </div>

            <div className="flex items-center justify-between pt-4">
              <span className="font-['Mulish'] text-sm text-[#666666]">
                Valor Pago
              </span>
              <span className="font-['Mulish'] text-lg font-extrabold text-[#20332f]">
                {maskMoney((valorPago ?? 0) / 100)}
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2.5 sm:flex-row">
          <ButtonV2
            className="h-[38px] w-full flex-1"
            onClick={handleVerMeusAgendamentos}
          >
            Ver meus agendamentos
            <img src="/assets/svgs/icon-arrow-forward.svg" alt="" />
          </ButtonV2>
          <ButtonV2
            variant="outline"
            className="h-[38px] w-full flex-1 border-[#adb7b5] text-[#666666]"
            onClick={handleVoltarAoInicio}
          >
            Voltar ao início
          </ButtonV2>
        </div>
      </div>

      <InfoV2 className="mt-12">
        <p className="font-['Mulish'] text-base text-[#2d2d2d]">
          No <strong>dia e hora marcados</strong>, é só levar seu veículo até
          a ECV/CIRETRAN.{" "}
          <strong>Não se esqueça de levar o documento em mãos!</strong> Um de
          nossos atendentes irá te receber e te orientar sobre os próximos
          passos.
        </p>
      </InfoV2>
    </ContainerV2>
  );
};
